import { getNick, setSelectedProfileId } from "../state-manager.js";
import { getProfiles } from '../state-manager.js';
import { hydrateFeeds } from './ui-feeds.js';
import { hydrateFoods } from './ui-foods.js';
import { resetSlider } from './ui-slider.js';

let selectedProfileIndex = 0;

function updateProfileSelector(profiles) {
  const prevBtn = document.getElementById('prevProfileBtn');
  const nextBtn = document.getElementById('nextProfileBtn');
  const nameLabel = document.getElementById('currentProfile');

  const nick = getNick();
  const current = profiles[selectedProfileIndex];
  nameLabel.textContent = current.name || 'No Name Set';
  console.log(`[Profile Selector] Current profile: ${nick} (${current.id})`);

  if (profiles.length <= 1) {
    prevBtn.classList.add('hidden');
    nextBtn.classList.add('hidden');
  } else {
    prevBtn.classList.remove('hidden');
    nextBtn.classList.remove('hidden');
  }

  // Update app state
  setSelectedProfileId(current.id);

  // Refresh UI panels
  hydrateFeeds(current.id);
  hydrateFoods(current.id);

  // Enable/disable buttons
  prevBtn.disabled = selectedProfileIndex === 0;
  nextBtn.disabled = selectedProfileIndex === profiles.length - 1;
}

export function initProfileNavigator() {
  const profilePanel = document.getElementById('profile-selector');
  profilePanel?.classList.remove('hidden');

  const profiles = getProfiles();
  if (!profiles?.length) return;

  updateProfileSelector(profiles);

  document.getElementById('prevProfileBtn').addEventListener('click', () => {
    if (selectedProfileIndex > 0) {
      resetSlider();
      selectedProfileIndex--;
      updateProfileSelector(profiles);
    }
  });

  document.getElementById('nextProfileBtn').addEventListener('click', () => {
    if (selectedProfileIndex < profiles.length - 1) {
      resetSlider();
      selectedProfileIndex++;
      updateProfileSelector(profiles);
    }
  });
}